import { Modal, SignInForm, SignUpForm } from '@components';
import { useScrollToTop } from '@hooks';
import { activityApi } from '@store';
import { ActivitiesSideNavTemplate } from '@templates';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { literature } from './ActivitiesPage.layoutProps';
import {
  AdditionalExercisesList,
  ArticlesList,
  CardDefenitionsList,
  LiteratureList,
  VideosList,
} from './components';

const ActivitiesPage = () => {
  const { i18n } = useTranslation();
  const [isModalVisible, setModalVisible] = useState(false);

  const {
    data: articles,
    isLoading: isGetArticlesQueryLoading,
    refetch: refetchArticles,
  } = activityApi.useGetArticlesQuery(undefined, {});
  const {
    data: videos,
    isLoading: isGetVideosQueryLoading,
    refetch: refetchVideos,
  } = activityApi.useGetVideosQuery(undefined, {});

  const activitiesSideContentState = useSelector(
    (state) => state.activitiesSlice.activitiesSideContentState
  );
  const authModalState = useSelector((state) => state.authSlice.authModalState);

  useEffect(() => {
    refetchArticles();
    refetchVideos();
  }, [i18n.language]);

  const handleLoginButtonClick = () => {
    setModalVisible(true);
  };

  const handleModalClose = () => {
    document.body.style.overflow = 'unset';
    setModalVisible(false);
  };

  const modalLayoutByState = {
    signIn: <SignInForm onSignInButtonClick={handleModalClose} />,
    signUp: <SignUpForm onSignUpButtonClick={handleModalClose} />,
  };

  const sideContentLayoutByState = {
    additionalExercises: (
      <AdditionalExercisesList onLoginButtonClick={handleLoginButtonClick} />
    ),
    articles: <ArticlesList articles={articles} />,
    cards: (
      <CardDefenitionsList
        activitiesSideContentState={activitiesSideContentState}
      />
    ),
    literature: <LiteratureList literature={literature} />,
    videos: <VideosList videos={videos} />,
  };

  useScrollToTop();

  return (
    <ActivitiesSideNavTemplate>
      <Modal
        isVisible={isModalVisible}
        modalContainerProps={{
          height: '100%',
          maxHeight: '618px',
        }}
        setModalVisible={setModalVisible}
        withBackdropNoise
      >
        {modalLayoutByState[authModalState]}
      </Modal>
      {!isGetArticlesQueryLoading &&
        !isGetVideosQueryLoading &&
        sideContentLayoutByState[activitiesSideContentState]}
    </ActivitiesSideNavTemplate>
  );
};

export default ActivitiesPage;
